import zh from "@/locales/zh.json"

type i18nKeys = keyof typeof zh

const CURRENT_LANG = "zh"
const wording = { zh: zh }
const t = (enWord: i18nKeys) => wording[CURRENT_LANG][enWord] ?? enWord

export default t
